import { render, staticRenderFns } from "./OtherDocuments.vue?vue&type=template&id=38a5f6b0&scoped=true"
import script from "./OtherDocuments.vue?vue&type=script&lang=js"
export * from "./OtherDocuments.vue?vue&type=script&lang=js"
import style0 from "./OtherDocuments.vue?vue&type=style&index=0&id=38a5f6b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a5f6b0",
  null
  
)

export default component.exports